var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.244078 12.2489C-0.0813592 11.9142 -0.0813592 11.3715 0.244078 11.0368L4.65482 6.5L0.244078 1.96323C-0.0813592 1.6285 -0.0813592 1.08579 0.244078 0.751051C0.569515 0.416316 1.09715 0.416316 1.42259 0.751051L6.42259 5.89391C6.74803 6.22864 6.74803 6.77136 6.42259 7.10609L1.42259 12.2489C1.09715 12.5837 0.569515 12.5837 0.244078 12.2489Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.75c42211ccc39bcbf374c01c27f0abda.svg";
export { ForwardRef as ReactComponent };